"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Square = void 0;
var react_1 = __importDefault(require("react"));
exports.Square = function (props) {
    var cx = props.cx, cy = props.cy, stroke = props.stroke;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", __assign({ x: cx - 11, y: cy - 11, width: 345, height: 345 }, { fill: stroke, opacity: 0.3 }, { viewBox: '0 0 1024 1024', className: 'hover-shape' }),
            react_1.default.createElement(SquareSvgPath, null)),
        react_1.default.createElement("svg", __assign({ x: cx - 5, y: cy - 5, width: 150, height: 150 }, { fill: stroke }, { viewBox: '0 0 1024 1024' }),
            react_1.default.createElement(SquareSvgPath, null))));
};
var SquareSvgPath = function () { return react_1.default.createElement("path", { d: 'M6 58 L6 6 L58 6 L58 58 Z' }); };
//# sourceMappingURL=Square.js.map